module.exports = __webpack_public_path__ + "static/img/03.fef6d22.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/immark/03.jpg
// module id = 394
// module chunks = 1